
import Contract from '@/components/Contract.vue'
import Tables from '@/components/common/TablesDb.vue'
import Select from '@/components/common/Select.vue'

import { defineComponent, ref, computed, markRaw, watch } from 'vue'
import { useApi } from '@/lib/api'
import { useRoute } from 'vue-router'
import Nav from '@/components/Nav.vue'
import InputText from '@/components/common/InputText.vue'
import InputNumeric from '@/components/common/InputNumeric.vue'
import { downloadStream, useAppViewedList } from '@/lib/common'
import { useStore } from 'vuex'

const actions = markRaw({
  template: `<router-link :to="{params: {id: data.id }}" tag="a" class="text-bold">Preglej </router-link>`,
  props: {
    data: {}
  }
})

export default defineComponent({
  components: { Tables, Contract, Nav, Select, InputText, InputNumeric },
  setup() {
    const { recordExists } = useAppViewedList()
    const _store = useStore()
    const _api = useApi()
    const _route = useRoute()
    const cols = ref([
      { field: 'id', caption: '#', dbField: 'np.id', hidden: true },
      { field: 'jnTitle', caption: 'Št. JN', dbField: 'jn' },
      { field: 'internalId', caption: 'Int. št. pogodbe', dbField: 'interni_opis' },
      { field: 'title', caption: 'Pogodba', dbField: 'np.naziv' },
      { field: 'contractor', caption: 'Izvajalec', dbField: 'izvajalec' },
      //{ field: 'client.title', caption: 'Naročnik', dbField: 'narocnik' },
      { field: 'value', caption: 'Znesek pogodbe', dbField: 'vrednost', class: 'text-right-important', format: { type: 'number', format: 2 } },
      { field: 'dateFrom', caption: 'Poročanje od', format: { type: 'date', format: 'DD.MM.YYYY' }, dbField: 'datum_od' },
      { field: 'dateTo', caption: 'Poročanje do', format: { type: 'date', format: 'DD.MM.YYYY' }, dbField: 'datum_do' },
      //{ field: 'active', caption: 'Aktivnost', format: { type: 'yesno' }, dbField: 'NP.aktiven' },
      { caption: 'Akcija', component: actions, class: 'nowrap actions' }
    ])
    const data = ref([])
    const statusList = [
      { id: null, text: '- izberi -' },
      { id: 1, text: 'Aktivne pogodbe' },
      { id: 2, text: 'Neaktivne/poročane pogodbe' }
    ]
    const filter = ref({ pagerPage: 1, pagerPageSize: 20, pagerSort: 'np.id desc', status: 1 })
    const hasId = computed(() => _route.params.id)
    const clientList = ref([])

    const getData = async (e?: any, f?: any) => {
      if (!hasId.value) {
        if (e) {
          filter.value.pagerPage = e.page
          filter.value.pagerSort = e.sort ? e.sort : 'np.id desc'
        } else if (filter.value.pagerPage > 1) {
          if (f) {
            filter.value.pagerPage = 1
          }
          return
        }
        const res = await _api.post<any>('contractList', filter.value, true)
        data.value = res.data
      }
    }

    const toXls = async () => {
      _store.commit('appLoading', true)
      try {
        const res = await _api.axios.post<any>('contractList?export=true', filter.value, { responseType: 'blob' })
        if (res.status === 200) {
          downloadStream(res.data, 'Pogodbe.xlsx')
        }
      } finally {
        _store.commit('appLoading', false)
      }
    }

    const getSifData = async () => {
      const res = await _api.get<any>('clientList')
      clientList.value = res.data.map((x: any) => ({
        id: x.id,
        text: x.title
      }))
      const n = { id: null, text: '- izberi -' }
      clientList.value.unshift(n as never)
    }

    watch(hasId, () => getData())

    getData()
    getSifData()

    return { cols, data, filter, getData, hasId, clientList, toXls, recordExists, statusList }
  }
})
